import Instituciones from "./Instituciones";
export default Instituciones;